import { call, put, takeLatest } from "redux-saga/effects";
import request from "../../../api/request";

function* getAllBankingOrders(payload) {
  try {

    yield put({
      type: "FETCH_BANKING_ORDERS_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const params = new URLSearchParams({
      page: payload.value.page.toString(),
      offset: payload.value.offset.toString()
    });

    if (payload.value.search) {
      params.append('search', payload.value.search);
    }

    if (payload.value.status) {
      const statuses = Array.isArray(payload.value.status)
        ? payload.value.status
        : [payload.value.status];

      statuses.forEach(st => {
        params.append('status', st);
      });
    }

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/banking/orders?${params.toString()}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "FETCH_BANKING_ORDERS_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load banking orders",
      },
    });
    yield put({
      type: "FETCH_BANKING_ORDERS_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* modifyOrderPaymentType(payload) {
  try {

    yield put({
      type: "MODIFY_ORDER_PAYMENT_TYPE_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/banking/orders/${payload.value.hashId}/change-payment-type`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "MODIFY_ORDER_PAYMENT_TYPE_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "MODIFY_ORDER_PAYMENT_TYPE_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* downloadBankingOrders(payload) {
  try {
    yield put({
      type: "DOWNLOAD_BANKING_ORDERS_REQUESTING",
    });

    const params = new URLSearchParams();

    if (payload.value.status) {
      const statuses = Array.isArray(payload.value.status)
        ? payload.value.status
        : [payload.value.status];

      statuses.forEach(st => {
        params.append('status', st);
      });
    }

    params.append('tab', payload.value.tab || 'pending');
    params.append('lang', payload.value.lang || 'es');

    if (payload.value.search) {
      params.append('search', payload.value.search);
    }

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/banking/orders/download?${params.toString()}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
      }),
    };

    const response = yield call(fetch, requestURL, headers);
    const blob = yield call([response, 'blob']);

    const tabNameMap = {
      pending: 'pendiente',
      processed: 'procesada',
      forManagement: 'por_gestionar',
      issues: 'incidencia',
    };

    const fileName = `banca_ordenes_${tabNameMap[payload.value.tab] || 'pendiente'}.xlsx`;

    const url = window.URL.createObjectURL(blob);
    let a = document.createElement("a");
    a.href = url;
    a.download = fileName;
    document.body.appendChild(a);
    a.click();
    a.remove();
    window.URL.revokeObjectURL(url);

    yield put({
      type: "DOWNLOAD_BANKING_ORDERS_SUCCESS",
    });
  } catch (error) {
    console.log(error);
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed download",
        message: "Failed download banking orders",
      },
    });
    yield put({
      type: "DOWNLOAD_BANKING_ORDERS_ERROR",
    });
  }
}

function* cancelOrder(payload) {
  try {

    yield put({
      type: "CANCEL_BANKING_ORDER_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/banking/orders/${payload.value.hashId}/cancel`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "CANCEL_BANKING_ORDER_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "CANCEL_BANKING_ORDER_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

function* resendOrder(payload) {
  try {

    yield put({
      type: "RESEND_BANKING_ORDER_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    let requestURL = `${process.env.REACT_APP_API_URL}/api/v1/banking/orders/resend-expired`;

    const headers = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "RESEND_BANKING_ORDER_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "RESEND_BANKING_ORDER_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

export function* watchBankingOrders() {
  yield takeLatest("FETCH_BANKING_ORDERS_REQUEST", getAllBankingOrders);
  yield takeLatest("DOWNLOAD_BANKING_ORDERS_REQUEST", downloadBankingOrders);
  yield takeLatest("MODIFY_ORDER_PAYMENT_TYPE_REQUEST", modifyOrderPaymentType);
  yield takeLatest("CANCEL_BANKING_ORDER_REQUEST", cancelOrder);
  yield takeLatest("RESEND_BANKING_ORDER_REQUEST", resendOrder);
}